exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-4399caab] {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.font-style[data-v-4399caab] {\n  font-family: \"Source Sans Pro\", Calibri, Candara, Arial, sans-serif;\n}\n.header-image[data-v-4399caab] {\n  position: fixed;\n  top: -50px;\n  padding-right: -50px;\n  padding-left: -50px;\n  padding-bottom: -50px;\n  width: 100%;\n}\n.footer-image[data-v-4399caab] {\n  position: fixed;\n  bottom: 100px;\n  margin-top: 20px;\n  padding-left: -50px;\n  padding-right: -50px;\n  width: 100%;\n}\n", ""]);

// exports
